import styled, { createGlobalStyle } from "styled-components";

export const Title = styled("h3")`
  margin: 0px;
  font-weight: 400;
  font-size: 22px;
  line-height: 26px;
`;

export const Description = styled.p`
margin: 0;
font-size: 16px;
`

export const GlobalStyle = createGlobalStyle`
  .grid {
    display: grid;
    gap: 16px;
    grid-auto-rows: 237px;
    grid-template-columns: repeat(auto-fill, minmax(169px, 1fr));
  }
`;


export const CategoryName = styled('h3')`
  margin: 0px;
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.active {
    font-weight: 500
  }
`

export const HorizontalScrollWrapper = styled('div')`
  margin: 0px -10px;
`

export const HorizontalScroll = styled('div')`
  overflow-x: scroll;
  display: flex;
  scroll-snap-type: x mandatory;
  padding: 10px;
  scroll-padding: 0 10px;

  ::-webkit-scrollbar {
    display: none;
  }

  & > * {
    scroll-snap-align: start;

    &:not(:last-child){
      margin-right: 16px;
    }
  }
`

export const CardsGrid = styled("div")`
  display: grid;
  gap: 16px;
  grid-auto-rows: 220px;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));

  @media(min-width: 768px){
    grid-auto-rows: 250px;
    grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  }

  @media(min-width: 1024px){
    grid-auto-rows: 250px;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
`;

export const Filters = styled("div")`
  max-width: 100%;
  display: inline-flex;
  overflow-x: auto;
  gap: 6px;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Filter = styled("div")`
  flex-shrink: 0;
`;

export const Total = styled('div')`
  position: relative;
  min-height: 29px;
  min-width: 29px;
  padding: 3px 8px;
  border-radius: 29px;
  color: ${({ theme }) => theme.colors.Primary};
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  overflow: hidden;

  &:before {
    content: "";
    background-color: ${({ theme }) => theme.colors.Primary};
    opacity: 0.1;
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    z-index: -1;
  } 
`

export const UnlockBadge = styled('div')`
  border-radius: 12px;
  padding: 4px 8px;
  background-color: rgba(255,255,255,.40);
  color: ${({ theme }) => theme.colors.Primary};
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PadlockBadge = styled('div')`
  min-height: 23px;
  border-radius: 12px;
  color: ${({ theme }) => theme.colors.Primary};
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Input = styled("input")`
  display: none;

  &:checked {
    & + label {
      background-color: ${({ theme }) => theme.colors.Primary};
      border: 1px solid ${({ theme }) => theme.colors.Primary};
      color: white;
    }

    & + label > ${Total} {
      background-color: rgba(255,255,255,.35);
      border: 1px solid ${({ theme }) => theme.colors.Primary};
      color: white;
    }
  }
`;

export const Label = styled("label") <{ blocked?: boolean }>`
  max-width: 280px;
  min-height: 45px;
  text-transform: capitalize;
  cursor: pointer;
  display: block;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  border-radius: 23px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  ${({ blocked }) => blocked ? "background-color: #96999A;" : "background-color: transparent;"} 
  ${({ blocked, theme }) => blocked ? "color: #FFFFFF;" : `color: ${theme.colors.Primary};`} 
  border: 1px solid ${({ blocked, theme }) => blocked ? "#CDCDCD" : theme.colors.Primary};

  padding: 7px 8px 7px 12px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;





export const FiltersTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  margin: 0px;

`